import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { toNumber } from 'ng-zorro-antd/core/util';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CurrentAffair } from 'src/app/core/interfaces/current-affair';
import { HttpRequestService, LocalStorageService } from 'src/app/core/services';
import { CommonService } from 'src/app/core/services/common.service';
import { RejectionReasonComponent } from 'src/app/shared/components/rejection-reason/rejection-reason.component';

@Component({
  selector: 'app-current-affairs',
  templateUrl: './current-affairs.component.html',
  styleUrls: ['./current-affairs.component.scss'],
})
export class CurrentAffairsComponent implements OnInit {
  allAffairs: CurrentAffair[] = [];
  allApprovedAffairs: CurrentAffair[] = [];
  isAddOrUpdate: boolean = true;
  totalDataCount = 0;
  totalApprovedDataCount = 0;
  pageSize = 12;
  pageIndex = 1;
  loading = false;
  searchAffair: Subject<string> = new Subject<string>();
  search = '';
  userRole: string = '';
  predefinedColors: string[] = ['magenta', 'blue', 'green', 'red', 'purple'];
  subAdminAddedAffairs: CurrentAffair[] = [];
  startDate: any;
  endDate: any;
  dateRange: any;
  index: number = 0;
  skipIndex: number = 0;
  // listView = true;
  // isOpenDetails = false;
  // active: boolean = false;
  // deActive: boolean = true;
  // isSubjectComponent: boolean = true;
  getColorForTag(tag: string): string {
    if (!tag) return this.predefinedColors[0];
    let hash = 0;
    for (let i = 0; i < tag.length; i++) {
      hash = tag.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % this.predefinedColors.length;
    return this.predefinedColors[index];
  }
  snapShootIndex: number = 0
  constructor(
    private httpRequestService: HttpRequestService,
    private notificationService: NzNotificationService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private modalService: NzModalService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.snapShootIndex = toNumber(this.activatedRoute.snapshot.queryParams.index) ;
    this.userRole = this.localStorageService.getItem('user').role;
    if(this.snapShootIndex){
      this.changeIndex(this.snapShootIndex)
    }
  }

  // on page load functions
  ngOnInit(): void {
    this.searchAffair.pipe(debounceTime(1000)).subscribe((success: string) => {
      this.search = success;
      this.getAllAffairs(this.index);
    });
  }
  onChangeDateRange(date: any) {
    this.startDate = date[0];
    this.endDate = date[1];
    this.getAllAffairs(this.index);
  }
  changeIndex(data: any) {
    this.router.navigate([], { queryParams: {index: data } });
    this.pageSize = 12;
    this.pageIndex = 1;
    this.allApprovedAffairs = [];
    this.allAffairs = [];
    this.index = data
    this.getAllAffairs();
  }

  /* Get all subjects */
  getAllAffairs(index: number = 0, skip = 0, sortBy?: any): void {
    index = index? index : this.index
    let params: any;
    params = { skip: this.skipIndex, limit: this.pageSize };
    if (this.search) {
      params.search = this.search;
    }
    if (sortBy) {
      params.sortBy = JSON.stringify(sortBy);
    }
    if (this.startDate && this.endDate) {
      params.startDate = this.startDate;
      params.endDate = this.endDate;
    } else {
      delete params.startDate;
      delete params.endDate;
    }
    if (index === 0) {
      params.approveStatus = 'approved';
    } else if (index === 1 && this.userRole === 'admin') {
      params.approveStatus = 'pending';
    } else if (index === 1 && this.userRole === 'subAdmin') {
      params.approveStatus = ['pending', 'rejected'];
    } else {
      delete params.approvedStatus;
    }
    this.loading = true;
    this.httpRequestService.request('get', 'current-affairs', params).subscribe(
      (result) => {
        this.loading = false;
        const data: CurrentAffair[] = result.data;
        if (index === 0) {
          this.allApprovedAffairs = data;
          this.totalApprovedDataCount = result.totalCount;
        } else {
          this.allAffairs = data;
          this.totalDataCount = result.totalCount;
        }
      },
      (err) => {
        this.loading = false;
      }
    );
  }
  deleteAffair(id: any) {
    this.httpRequestService
      .request('delete', `current-affairs/${id}`)
      .subscribe((result: any) => {
        this.notificationService.success(
          '',
          'Current Affair Deleted Successfully'
        );
        this.getAllAffairs(this.index);
      });
  }
  /* For Pagination / Sending skip */
  onQueryParamsChange(params: NzTableQueryParams): void {
    this.allApprovedAffairs = [];
    this.allAffairs = [];
    const { pageSize, pageIndex } = params;
    this.skipIndex = pageSize * (pageIndex - 1)
    this.getAllAffairs(this.index, pageSize * (pageIndex - 1));
  }
  /* For Pagination / Sending skip for grid view*/
  /* Status change*/
  updateStatus(id: string, status: boolean): void {
    this.httpRequestService
      .request('put', `current-affairs/active-inactive/${id}`, {
        status: !status,
      })
      .subscribe((result: any) => {
        this.notificationService.success('', 'Status Updated Successfully');
        this.getAllAffairs(this.index);
      });
  }
  updatePendingStatus(id: string, pendingStatus: string) {
    this.httpRequestService
      .request('put', `current-affairs/approved-rejected/${id}`, {
        approveStatus: 'approved',
      })
      .subscribe((result: any) => {
        this.notificationService.success('', 'Status Updated Successfully');
        this.getAllAffairs(this.index);
      });
  }
  openRejectionReason(id: string, pendingStatus: string) {
    const rejectionReason = this.modalService.create({
      nzTitle: 'Add A Reason',
      nzContent: RejectionReasonComponent,
      nzWidth: '800px',
      nzFooter: null,
      nzComponentParams: {
        updateId: id,
        component: 'current-affairs',
      },
      nzCancelText: null,
      nzOkText: null,
    });

    const questionService = rejectionReason.afterClose.subscribe(
      (data: any) => {
        this.getAllAffairs(this.index);
      }
    );
  }

  // Search affairs
  searchAffairs(event: any): void {
    this.searchAffair.next(event);
  }
}
